/**
 * Sends the selected Orion configuration via email.
 * @param {string} email - The user's email address.
 * @param {Object} selectedModules - The object containing both modules and rack model information.
 * @param {number} price - The estimated price.
 * @param {number} deliveryTime - The estimated delivery time.
 * @returns {Promise<Object>} - The response object from the API.
 * @throws {Error} - Throws an error if the network request fails.
 */
export const sendOrionConfiguration = async (email, selectedModules, price, deliveryTime) => {

    const { modules } = selectedModules;

    try {
        /**
        * Send a POST request to the API endpoint with the configuration data.
        * @type {Promise<Response>}
        */
        const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/configuratorOrion/sendConfiguration', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, selectedModules: modules, price, deliveryTime }),
        });

        console.log("Request sent. Waiting for response...");
        /**
        * Check if the response status is OK (200-299).
        */
        if (!response.ok) {
            console.error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
            /**
             * Return an error object if the response status is not OK.
             * @type {Object}
             */
            return { status: 'error', message: 'Failed to send configuration, server responded with an error.' };
        }
        /**
        * Parse the response data as JSON.
        * @type {Promise<Object>}
        */
        const data = await response.json();
        console.log("Response data:", data);
        /**
        * Return the response data.
        * @type {Object}
        */
        return data;
    } catch (error) {
        console.error("Error occurred while sending configuration:", error);
        /**
         * Re-throw the error to propagate it up the call stack.
         * @throws {Error}
         */
        throw error;
    }
};
